import React from 'react';
import { Layout, Seo } from '@layout';
import { HorizontalAnimation } from '@components/HorizontalAnimation';
import { careersPageData } from '@data-ts/pages/careers';
import {
  HeroSection,
  FindYourJoy,
  JoyTeams,
  SomethingBig,
  OurValues,
  CultureSection,
  BeAmazing,
  DirectorOfEngineering,
  HowWeWork,
  ProductDesigner,
  CareersFooter,
} from '@sections/careers';

const CareersNew = () => {
  return (
    <Layout
      transparentJoyLogoColor="neutra6"
      transparentHeaderButtonVariant="primary"
      transparentHeaderLinkVariant="navLink"
      isTransparentHeader={true}
    >
      <Seo title={careersPageData.seo.title} description={careersPageData.seo.content} canonicalURL={'https://withjoy.com/careers/'} />
      <HeroSection />
      <FindYourJoy />
      <HorizontalAnimation
        eyebrow={careersPageData.remoteTeam.eyebrow}
        title={careersPageData.remoteTeam.title}
        body={careersPageData.remoteTeam.body}
        cta={careersPageData.remoteTeam.cta}
        ctaId="careersRemoteTeam"
        ctaLink={careersPageData.allPostionsCta}
        paddingBottom={[500, 920]}
        animation={careersPageData.remoteTeam.animation}
      />
      <JoyTeams />
      <SomethingBig />
      <OurValues />
      <CultureSection />
      <BeAmazing />
      <DirectorOfEngineering />
      <HowWeWork />
      <ProductDesigner />
      <CareersFooter />
    </Layout>
  );
};

export default CareersNew;
